export const apiRootUrl = () => daptiv.ptb.WebConfig.apiUrl

export const deleteComment = (taskId, commentId) => `${apiRootUrl()}/tasks/${taskId}/comments/${commentId}`
export const addComment = (taskId) => `${apiRootUrl()}/tasks/${taskId}/comments`
export const getComments = (taskId) => `${apiRootUrl()}/tasks/${taskId}/comments`
export const getProject = (projectId) => `${apiRootUrl()}/project/${projectId}`
export const getProjectMembers = (projectId) => `${apiRootUrl()}/project/${projectId}/members`
export const getTasks = (projectId) => `${apiRootUrl()}/project/${projectId}/tasks`
export const putTaskPosition = (projectId, taskId) => `${apiRootUrl()}/project/${projectId}/tasks/${taskId}/position`
export const putTask = (projectId, taskId) => `${apiRootUrl()}/project/${projectId}/tasks/${taskId}`
export const getBoardDef = (projectId) => `${apiRootUrl()}/project/${projectId}/def`
export const setBoardDef = (projectId) => `${apiRootUrl()}/project/${projectId}/def`
export const getBoardDefs = () => `${apiRootUrl()}/swimlanes`
export const boardDefs = () => `${apiRootUrl()}/swimlanes`
export const feedbackRoute = () => `${apiRootUrl()}/feedback`
export const getUserInfo = () => `${apiRootUrl()}/userinfo`
export const addNewTask = (projectId) => `${apiRootUrl()}/project/${projectId}/tasks`
export const deleteTask = (projectId, taskId) => `${apiRootUrl()}/project/${projectId}/tasks/${taskId}`
export const getTaskLinks = (taskId) => `${apiRootUrl()}/tasks/${taskId}/links`
export const postTaskLink = (taskId) => `${apiRootUrl()}/tasks/${taskId}/links`
export const deleteTaskLink = (taskId, linkId) => `${apiRootUrl()}/tasks/${taskId}/links/${linkId}`
export const getTaskChecklistItems = (taskId) => `${apiRootUrl()}/tasks/${taskId}/checklistitems`
export const addTaskChecklistItem = (taskId) => `${apiRootUrl()}/tasks/${taskId}/checklistitems`
export const moveTaskChecklistItem = (taskId, itemId) => `${apiRootUrl()}/tasks/${taskId}/checklistitems/${itemId}/position`
export const updateTaskChecklistItem = (taskId, itemId) => `${apiRootUrl()}/tasks/${taskId}/checklistitems/${itemId}`
export const deleteTaskChecklistItem = (taskId, itemId) => `${apiRootUrl()}/tasks/${taskId}/checklistitems/${itemId}`



// WEBPACK FOOTER //
// ./src/ajax/paths.js